import { cn } from "@/lib/utils"

type QuantumPlusBadgeVariant = "accent" | "muted" | "report"

type QuantumPlusBadgeProps = {
  variant?: QuantumPlusBadgeVariant
  className?: string
}

const VARIANT_CLASSES: Record<QuantumPlusBadgeVariant, string> = {
  accent: "text-xs font-bold uppercase tracking-[0.2em] text-[#cf1f66]",
  muted: "text-[10px] font-semibold uppercase tracking-[0.16em] text-[#6b6080]",
  report: "performance-report-kicker",
}

export function QuantumPlusBadge({
  variant = "accent",
  className,
}: QuantumPlusBadgeProps) {
  return (
    <p className={cn(VARIANT_CLASSES[variant], className)}>Quantum+</p>
  )
}
